import react from 'react'
import styled from 'styled-components'
import { MdKeyboardArrowRight, MdAccountBox } from 'react-icons/md'
import { SelectedProps } from '../Layout/CommonStyle'

type mentorProps = {
  id: number
  name: string
  // group: string
  selected?: boolean
  onClick?: () => void
}

function MentorLine(props: mentorProps): React.ReactElement {
  return (
    <Line onClick={props.onClick} selected={props.selected ? 'selected' : ''}>
      <Photo>
        <MdAccountBox />
      </Photo>
      <Info>
        <Name>{props.name}</Name>
        {/* <Group>{props.group}</Group> */}
      </Info>
      <Icon>
        <MdKeyboardArrowRight />
      </Icon>
    </Line>
  )
}

const Line = styled.div`
  padding: 5px 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  background-color: ${(props: SelectedProps) =>
    props.selected === 'selected' ? '#ffd597' : 'white'};

  &:hover {
    background-color: rgba(0, 0, 0, 0.08);
  }
`
const Photo = styled.div`
  padding: 0;
  align-self: flex-start;

  & > svg {
    font-size: 3rem;
    padding: 0;
    margin: 0;
    vertical-align: bottom;
  }
`
const Info = styled.div`
  font-size: 0.85rem;
  flex-grow: 2;
  text-align: left;
`

const Name = styled.div`
  color: rgba(0, 0, 0, 0.78);
  font-weight: 650;
`
const Group = styled.div`
  color: rgba(0, 0, 0, 0.68);
  font-size: 0.78rem;
`
const Icon = styled.div`
  font-size: 1.5rem;
  color: #1023c7;
`

export default MentorLine
